import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface DialogData {
  complianceType: string;
  facilityName: string;
  imageUrl: string;
}

@Component({
  selector: 'app-site-redinessdialog',
  templateUrl: './site-redinessdialog.component.html',
  styleUrls: ['./site-redinessdialog.component.css']
})

export class SiteRedinessdialogComponent implements OnInit {


  imageSelected: string;

  constructor(private router: Router,
              public dialogRef: MatDialogRef<SiteRedinessdialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.imageSelected = this.data.imageUrl;
  }

  onClose() {
    this.dialogRef.close();
  }
}
